import FormAutoComplete from '@/views/components/Inputs/FormAutoComplete';
import type { AutoCompleteProps, FormItemProps } from 'antd';
import i18n from 'i18next';
import { type FC, useMemo } from 'react';
import { useGetCountryList } from '../../hooks';
import type { CountryInfo } from '../../types';

interface CountryCallingCodeSelectProps
  extends Pick<FormItemProps, 'rules' | 'name'>,
    Pick<AutoCompleteProps, 'value' | 'placeholder'> {
  label?: string;
  editMode?: boolean;
  margin?: string;
  onChange?: (value?: CountryInfo & { label: string; value: string }) => void;
  mode?: string;
  className?: string;
  tabIndex?: number;
  disableValidation?: boolean;
  selectedCountry?: string[] | string;
  isRemoved?: boolean;
  labelWithValue?: boolean;
  dataTestId?: string;
  popupClassName?: string;
}

export const CountryCallingCodeSelect: FC<CountryCallingCodeSelectProps> = ({
  placeholder = i18n.t('translation:default.fields.country.placeholder'),
  label = i18n.t('translation:default.fields.country.label'),
  rules = [],
  name,
  editMode,
  margin,
  onChange,
  value = '',
  popupClassName,
}) => {
  const { data: countryList = [], isLoading } = useGetCountryList();

  const options = useMemo(() => {
    // TODO: remove label and value from CountryCallingCodeSelect options
    return countryList.map((row) => ({
      ...row,
      label: `${row.countryName}( +${row.countryCallingCode} )`,
      value: `+${row.countryCallingCode}`,
    }));
  }, [countryList]);

  return (
    <FormAutoComplete
      loading={isLoading}
      options={options}
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      onChange={onChange}
      value={value}
      popupClassName={popupClassName}
    />
  );
};
